const API_URL = import.meta.env.VITE_ORDERS_API_URL || 'http://localhost:3002';

export interface OrderCommentRecord {
  bc_order_id: number;
  internal_order_id: string;
  invoice_id: string;
  billing_company?: string;
}

export const fetchOrderComments = async (
  orderIds: number[],
): Promise<Record<string, { internalOrderId: string; invoiceId: string; companyName: string }>> => {
  if (!orderIds.length) return {};

  const response = await fetch(
    `${API_URL}/api/orders?order_ids=${orderIds.join(',')}`,
  );

  if (!response.ok) throw new Error(`Orders API error: ${response.status}`);

  const json: { data: OrderCommentRecord[] } = await response.json();

  const map: Record<string, { internalOrderId: string; invoiceId: string; companyName: string }> = {};

  (json.data ?? []).forEach((record) => {
    map[String(record.bc_order_id)] = {
      internalOrderId: record.internal_order_id,
      invoiceId: record.invoice_id,
      companyName: record.billing_company ?? '',
    };
  });

  return map;
};

export interface OrderSearchResult {
  bcOrderId: number;
  internalOrderId: string;
  invoiceId: string;
  status: string;
  dateCreated: string;
  billingCompany: string;
  poNumber: string;
  totalIncTax: string;
}

export const searchOrderComments = async (
  q: string,
  customerId?: number,
  offset = 0,
  limit = 10,
): Promise<{ results: OrderSearchResult[]; totalCount: number }> => {
  if (!q.trim()) return { results: [], totalCount: 0 };

  const params = new URLSearchParams({
    q: q.trim(),
    offset: String(offset),
    limit: String(limit),
  });
  if (customerId) params.append('customer_id', String(customerId));

  const response = await fetch(`${API_URL}/api/orders/search?${params}`);
  if (!response.ok) return { results: [], totalCount: 0 };

  const json: { data: OrderCommentRecord[]; totalCount: number } = await response.json();

  return {
    results: (json.data ?? []).map((record: any) => ({
      bcOrderId: record.bc_order_id,
      internalOrderId: record.internal_order_id,
      invoiceId: record.invoice_id,
      status: record.status || '',
      dateCreated: record.date_created || '',
      billingCompany: record.billing_company || '',
      poNumber: record.po_number || '',
      totalIncTax: record.total_inc_tax || '0',
    })),
    totalCount: json.totalCount ?? 0,
  };
};
